import { CLEAR_MODAL, SET_LOADING, SET_MODAL } from 'store/types/common';

const initialState = {
  modal: {
    isOpen: false,
    title: '',
    message: '',
    onConfirm: () => {},
    onCancel: () => {},
    confirmText: '削除',
    cancelText: 'キャンセル',
    type: 'confirm',
    classWrapModal: '',
    icon: null,
  },
  loading: {
    isOpen: false,
  },
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MODAL:
      return {
        ...state,
        modal: {
          ...state.modal,
          ...action?.payload,
        },
      };
    case CLEAR_MODAL:
      return {
        ...state,
        modal: initialState.modal,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          ...action?.payload,
        },
      };
    default:
      return state;
  }
};

export default commonReducer;
